module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-wrap",
    class: {
      'component-padded': _vm.base.padded, 'active': _vm.active
    }
  }, [_c('div', {
    staticClass: "current-active"
  }), _vm._v(" "), (_vm.base.title) ? _c('div', {
    staticClass: "component-header"
  }, [_c('div', {
    staticClass: "component-title"
  }, [_c('div', [_vm._v(_vm._s(_vm.base.title))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.base.subtitle))])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "goods-card"
  }, [_c('div', {
    staticClass: "goods",
    class: _vm.config.style
  }, [_c('img', {
    staticClass: "thumbnail",
    attrs: {
      "src": _vm.data[0].img_url || (_vm.config.style === 'card' ? 'https://fakeimg.pl/80x80/EFEFEF/CCC/?text=img&font=lobster' : 'https://fakeimg.pl/288x120/EFEFEF/CCC/?text=img&font=lobster')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticClass: "goods-title"
  }, [_vm._v("\n            " + _vm._s(_vm.data[0].item_name || '商品标题') + "\n          ")]), _vm._v(" "), (_vm.config.style === 'card') ? [_c('div', {
    staticClass: "tips"
  }, [_vm._v("\n              点击查看产品详情\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "sales-num"
  }, [_c('i', {
    staticClass: "iconfont icon-user-friends"
  }), _vm._v(_vm._s(_vm.data[0].sales || 0))])] : [_c('div', {
    staticClass: "price"
  }, [_vm._v("\n              价格： ¥" + _vm._s(_vm.data[0].price / 100) + "\n            ")])]], 2)]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-more"
  }, [_c('div', {
    staticClass: "three-dot"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "footer-btn"
  }, [_vm._v("\n          加入心愿\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "footer-btn"
  }, [_vm._v("\n          加入购买\n        ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1b50cda3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b50cda3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/goods.vue
// module id = 2512
// module chunks = 0